import { atom, selector } from 'recoil'
import {
  MAX_POPUP_NOTIFICATION_LAYER,
  CUSTOM_ERROR_MESSAGE_MAP
} from '@/constants/notification'

const _notificationListState = atom({
  key: '_NotificationList',
  default: []
})

export const unreadNotificationCountValue = selector({
  key: 'UnreadNotificationCount',
  get: ({ get }) =>
    get(_notificationListState).filter(({ markRead }) => markRead === 0).length
})

export const notificationListState = selector({
  key: 'NotificationList',
  get: ({ get }) => get(_notificationListState),
  set: (
    { get, set, reset },
    { initialList, notification, markAllRead, resetDefault }
  ) => {
    if (resetDefault) {
      return reset(_notificationListState)
    }

    if (markAllRead) {
      const list = JSON.parse(JSON.stringify(get(_notificationListState)))
      return set(
        _notificationListState,
        list.map(data => {
          data.markRead = 1
          return data
        })
      )
    }

    set(
      _notificationListState,
      initialList
        ? initialList
        : [notification].concat(get(_notificationListState))
    )
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const latestNotificationValue = selector({
  key: 'LatestNotification',
  get: ({ get }) => get(_notificationListState)[0] || {},
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const _popupNotificationListState = atom({
  key: '_PopupNotificationList',
  default: []
})

export const popupNotificationListState = selector({
  key: 'PopupNotificationList',
  get: ({ get }) => get(_popupNotificationListState),
  set: ({ get, set, reset }, { notification, remove }) => {
    const notificationList = get(_popupNotificationListState).concat([])
    if (remove) {
      notificationList.pop()
      return set(_popupNotificationListState, notificationList)
    }
    notificationList.length === MAX_POPUP_NOTIFICATION_LAYER &&
      notificationList.pop()

    if (CUSTOM_ERROR_MESSAGE_MAP[notification.code]) {
      notification.message = CUSTOM_ERROR_MESSAGE_MAP[notification.code]
    }

    set(_popupNotificationListState, [notification].concat(notificationList))
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})
